// extracted by mini-css-extract-plugin
export default {"letterSpace":"site-pie-chart-labels_letterSpace__0oVQ8"};